export class YouTubeThumb {
  public static pluginName = "YouTubeThumb"

  public static requires: never[] = []

  public static afterInit(): void {
    // Plugin logic without CKEditor5 imports
  }
}
